import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import './FilterSelector.scss';

type FilterSelectorProps = {
    label: string;
    autoFlowGridOnContent?: boolean;
} & React.PropsWithChildren;

const FilterSelector: React.FC<FilterSelectorProps> = ({ label, autoFlowGridOnContent = false, children }) => {
    return (
        <section
            className={classNames('filter-selector__wrapper', { 'auto-flow-grid-content': autoFlowGridOnContent })}
        >
            <span className="filter-selector__label">{label}</span>
            <div className="filter-selector__content">{children}</div>
            <Icon type={IconTypes.LITEN_PIL_HOEYRE} />
        </section>
    );
};

export default FilterSelector;
